<template lang="pug">
  e-form(
  :formValidator="formValidator"
    :enablePerfectScrollbar="false"
  formClass=""
  ).body.user-profile-change-password
    div.col
      div.col-block
      div.col-block
        e-form-group(
        :name="PASSWORD.OLD"
        inputType="password"
        label="Старый пароль"
          :model="fields"
            :tabView="currentTab"
            :required="true"
        )
        e-form-group(
        :name="PASSWORD.PASS_NEW"
        inputType="password"
        label="Новый пароль"
          :model="fields"
            :tabView="currentTab"
            :required="true"
        )
        e-form-group(
        :name="PASSWORD.PASS_REPEAT"
        inputType="password"
        label="Повторите пароль"
          :model="fields"
            :tabView="currentTab"
            :required="true"
        )
      div.col-block.buttons
        button(
        @click="saveTab()"
          :disabled="formFreezed"
        ).user-button.user-button--save {{formFreezed ? 'Сохранение' : 'Сохранить'}}

    div.col
    div.col
</template>

<script>
  import validationRules from '../../../mixins/validation-rules.js'
  import formBaseMixin from '../../../components/form/form-base-mixin.js'
  import {account} from '../../../api/api-endpoints.js'

  const PASSWORD = {
    OLD: 'old_password',
    PASS_NEW: 'password',
    PASS_REPEAT: 'repeat_password'
  }

  export default {
    name: 'user-profile-change-password',
    mixins: [validationRules, formBaseMixin],
    title: false,
    props: {
      currentTab: {
        type: String,
        default: 'tab4'
      }
    },
    data () {
      return {
        fields: {
          [PASSWORD.OLD]: '',
          [PASSWORD.PASS_NEW]: '',
          [PASSWORD.PASS_REPEAT]: ''
        }
      }
    },
    computed: {
      PASSWORD () {
        return PASSWORD
      }
    },
    methods: {
      onSuccess () {
        this.showOnSuccess('Профиль обновлен')
        this.unFreezeFrom()
        this.$router.push({path: '/'})
      },
      getStoreAction () {
        return 'updateModel'
      },
      getUpdateOrCreateUrl () {
        return account.password()
      },
      saveTab () {
        this.sendForm()
      },
      additionalValidate: async function (hasError = false, errors = {}) {
        let manualErrors = {}
        this.minLen([this.PASSWORD.PASS_NEW, this.PASSWORD.PASS_REPEAT], manualErrors)
        this.checkRegExp([this.PASSWORD.PASS_NEW, this.PASSWORD.PASS_REPEAT], manualErrors, '[A-Z]', 'Должна быть хотя бы одна заглавная буква. ')
        this.checkRegExp([this.PASSWORD.PASS_NEW, this.PASSWORD.PASS_REPEAT], manualErrors, '[0-9]', 'Должна быть хотя бы одна цифра. ')
        this.checkRegExp([this.PASSWORD.PASS_NEW, this.PASSWORD.PASS_REPEAT], manualErrors, '^([\x03-\x7E]{1,})$', 'Допустимые символы - латинские буквы, цифры, спец.символы. ')

        if (Object.keys(manualErrors).length === 0) {
          this.compare([this.PASSWORD.PASS_NEW, this.PASSWORD.PASS_REPEAT], manualErrors)
        }

        if (Object.keys(manualErrors).length > 0) {
          this.formValidator.handleServerErrors({data: {errors: manualErrors}}, this)
          return Promise.reject(1)
        }
        return Promise.resolve(1)
      },
      getItemEndpoint () {
        return null
      }
    }
  }
</script>
